import React, { useState } from 'react';
import { Breadcrumb, Button, message } from 'antd'; // Import message for error notifications
import {
  HomeIcon,
  DocumentChartBarIcon,
} from '@heroicons/react/16/solid';
import PayslipTable from './payslipTable';
import PayslipModal from './payslipModal';
import ReportsModal from './reportsModal';
import { useNavigate } from 'react-router-dom';
import AddPayslipForm from './addPayslip';

const Payslipcomp = () => {
  const [isPayslipVisible, setPayslipVisible] = useState(false);
  const [isReportVisible, setReportVisible] = useState(false);
  const [isIndividualVisible, setIndividualVisible] = useState(false);
  let navigate = useNavigate();

  const items = [
    {
      href: '/',
      title: (
        <span className="flex sm:gap-2 items-center">
          <HomeIcon className="h-6 w-6 text-gray-500" />
          <span className="text-gray-400 sm:text-lg">Home</span>
        </span>
      ),
    },
    {
      href: '/payslip',
      title: (
        <span className="flex sm:gap-2 items-center">
          <DocumentChartBarIcon className="h-6 w-6 text-gray-300" />
          <span className="text-gray-400 sm:text-lg">Pay Slip</span>
        </span>
      ),
    },
  ];

  const handleIndividualPayslipOk = async (values) => {
    // console.log("Payslip individual:", values);
    const { month, year, employeeId } = values;
    if (!month || !year || !employeeId) {
      message.error("Please fill in all required fields.");
      return;
    }
    try {
      navigate(`/payslip/individualpayslip?month=${month}&year=${year}&empid=${employeeId}`);
      setIndividualVisible(false)
    } catch (error) {
      console.log(error);
      message.error("An error occurred while processing the request.");
    }
  };

  const handlePayslipOk = async (values) => {
    // console.log("Payslip values:", values);
    // Add validation or API call logic if needed
    setPayslipVisible(false);
  };

  const handleReportOk = async (values) => {
    // console.log("Report values:", values);
    const { month, year } = values;

    // Validate month and year
    if (!month || !year) {
      message.error("Please select both month and year.");
      return;
    }

    try {
      // Navigate to the report page
      navigate(`/payslip/report?month=${month}&year=${year}`);
      setReportVisible(false);
    } catch (error) {
      console.log(error);
      message.error("An error occurred while generating the report.");
    }
  };

  return (
    <div>
      <div className="flex flex-wrap py-8 px-4 sm:p-10 justify-between items-center gap-4">
        <div className="flex flex-col gap-2 text-xl md:text-4xl font-black">
          Pay Slip
          <Breadcrumb items={items} />
        </div>
        <div className="flex space-x-2">
          <Button
            type="primary"
            className="bg-green-500 border-none hover:bg-green-600"
            onClick={() => setIndividualVisible(true)}
          >
            PaySlip
          </Button>
          <Button
            type="primary"
            className="bg-green-500 border-none hover:bg-green-600"
            onClick={() => setReportVisible(true)}
          >
            Report
          </Button>
          <Button
            type="primary"
            className="bg-green-500 border-none hover:bg-green-600"
            onClick={() => setPayslipVisible(true)}
          >
            Add Payslip
          </Button>
        </div>
      </div>

      <PayslipTable />

      <PayslipModal
        visible={isIndividualVisible}
        onCancel={() => setIndividualVisible(false)}
        onSubmit={handleIndividualPayslipOk}
      />
      <ReportsModal
        visible={isReportVisible}
        onCancel={() => setReportVisible(false)}
        onOk={handleReportOk}
      />
      <AddPayslipForm
        visible={isPayslipVisible}
        onCancel={() => setPayslipVisible(false)}
        onOk={handlePayslipOk}
      />
    </div>
  );
};

export default Payslipcomp;
// 
